import { Target } from "@phosphor-icons/react";
import {
    Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "../../components/ui/dialog";
import EmptyState from "../../components/EmptyState";
import { cn as classJoin } from "../../lib/utils";

export default function DrillDownDialog({ open, onOpenChange, title, items, columns }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-4xl">
                <DialogHeader>
                    <DialogTitle className="font-display flex items-center gap-2">
                        <Target size={18} className="text-slate-700" /> {title}
                    </DialogTitle>
                    <DialogDescription>
                        {items.length} {items.length === 1 ? "deal" : "deals"} matching this segment.
                    </DialogDescription>
                </DialogHeader>
                <div className="max-h-[60vh] overflow-auto rounded-md border border-slate-200" data-testid="drilldown-table-wrapper">
                    {items.length === 0 ? (
                        <EmptyState icon={<Target size={32} weight="thin" />} title="Nothing to drill into" />
                    ) : (
                        <table className="w-full text-sm">
                            <thead className="bg-slate-50 border-b border-slate-200 sticky top-0">
                                <tr className="text-left">
                                    {columns.map((c) => (
                                        <th key={c.key} className={classJoin("px-4 py-2 reedos-eyebrow", c.align === "right" && "text-right")}>{c.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((row) => (
                                    <tr key={row.id} className="border-t border-slate-100 reedos-row-hover">
                                        {columns.map((c) => (
                                            <td key={c.key} className={classJoin("px-4 py-2 text-xs", c.align === "right" && "text-right reedos-data")}>
                                                {c.render ? c.render(row) : row[c.key] || "—"}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}
